import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';
import { Device } from 'DeviceUtils';

const baseStyles = {
    viewContainer: {
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        flexDirection: 'row',
        paddingHorizontal: 10,
        position: 'relative'
    },
    windowMobile: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: Device.isTablet ? 0 : 44
    },
    logoBox: {
        alignItems: 'center'
    },
    logo: {
        alignSelf: 'center',
        justifyContent: 'center',
        width: 189.91,
        height: 50.64,
        marginBottom: 40,
        paddingHorizontal: 18
    },
    iconsContainer: {
        flexDirection: 'row',
        backgroundColor: 'black',
        height: 110
    },
    descriptionBox: {
        width: Device.isTabletOrWeb ? '50%' : '100%',
        paddingHorizontal: Device.isTablet ? 0 : 18
    },
    hrStyle: {
        width: Device.isTablet ? '40%' : '80%',
        marginVertical: 20,
        alignSelf: 'center',
        paddingHorizontal: Device.isTablet ? 0 : 18
    },
    innerItemContainer: {
        paddingVertical: 12,
        backgroundColor: '#FCFCFC26',
        alignItems: 'center',
        marginTop: 16,
        // paddingLeft: 12,
        // paddingRight: 12,
        marginRight: 5
    },
    innerItemContainerSmaller: {
        paddingVertical: 12,
        backgroundColor: '#FCFCFC26',
        alignItems: 'center',
        marginTop: 16,
        marginRight: 5
    },
    itemIcon: {
        width: 30,
        height: 30
    },
    itemText: {
        paddingVertical: 4,
        fontFamily: Theme.regularFont,
        fontSize: Device.isAndroid ? Theme.fontSizes.description - 2 : Theme.fontSizes.description,
        color: Theme.primaryTextColor,
        textAlign: 'center',
        width: 105,
        height: 75
    },
    buttonContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 45
    },
    button: {
        marginTop: 45,
        width: Device.isPhone ? '80%' : '30%',
        maxWidth: Device.isPhone ? '80%' : '30%',
        alignSelf: 'center',
        paddingHorizontal: 18
    },
    subTitle: {
        ...fontStyles.subtitle,
        width: Device.isTabletOrWeb ? '50%' : '90%',
        marginBottom: 24,
        textAlign: 'center',
        letterSpacing: 0.68
    },

    headerContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    title: {
        ...fontStyles.title,
        fontFamily: Theme.regularFont,
        width: Device.isPhone ? '65%' : '100%',
        textAlign: 'center'
    },
    greyText: {
        ...fontStyles.subtitle,
        color: 'white',
        width: Device.isTabletOrWeb ? '90%' : '95%',
        textAlign: 'center',
        letterSpacing: 0.68,
        alignSelf: 'center',
        paddingHorizontal: Device.isTablet ? 0 : 18
    },
    iconCloseContainer: {
        marginTop: Device.isAndroid ? 17 : 40,
        paddingHorizontal: 0,
        position: 'absolute',
        top: 0,
        right: 25
    },
    scrollContainer: {
        flexGrow: 1
    }
};

export default StyleSheet.create(baseStyles);
